import { render, staticRenderFns } from "./CalendarHeat.vue?vue&type=template&id=0620a39a&scoped=true&"
import script from "./CalendarHeat.vue?vue&type=script&lang=js&"
export * from "./CalendarHeat.vue?vue&type=script&lang=js&"
import style0 from "./CalendarHeat.vue?vue&type=style&index=0&id=0620a39a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0620a39a",
  null
  
)

export default component.exports